import type { TableView } from "owa-mail-list-store";
import { mutatorAction } from "satcheljs";

const toggleSelectAllStateMutator: (tableView: TableView) => void = mutatorAction("toggleSelectAllState", function toggleSelectAllState(tableView: TableView): void {
    tableView.isInSelectAllState = !tableView.isInSelectAllState;
});
export default toggleSelectAllStateMutator;
